module.exports = __webpack_public_path__ + "img/950faae.jpg";